export const ONBOARDING_CONSTANTS = {
  THANK_YOU_TITLE: "Onboarding Complete!",
  THANK_YOU_DESCRIPTION:
    "Thank you for completing the setup. Your AI agent is now being configured.",
  NEXT_STEPS_HEADING: "What's next?",
  NEXT_STEP_1_TEXT: "Check your inbox for a confirmation email with your login details.",
  NEXT_STEP_2_TEXT: "Your agent will be live on the provided number shortly.",
  NEXT_STEP_3_TEXT: "Log in to your dashboard to view analytics and customize your agent.",
  BUTTON_TEXT: "Go to Dashboard",
  DASHBOARD_URL: "https://ai.curebytesai.co.uk/#login",
};